export const review = [
  {
    comment:
      "Went to The Grove for dinner on a busy Saturday night. Found the food and service to be excellent. We had a bunch of different items from the menu and all were  delicious and cooked just right. Nice owner and staff. Will be back for sure.",
    user: "-Ralph Sommer",
    stars: 5,
  },
  {
    comment:
      "Hannah was the bomb. The endless mimosas made the girls happy. World cup and Xmas trees. Great day. Cant drink all day if you don't start in the morning.",
    user: "-C.Cunningham",
    stars: 4.5,
  },
  {
    comment:
      "I’ve had over dozen different dishes and they have all been beyond impressive. The food is cooked to perfection, the staff is all amazing and friendly, the service is well served! Highly highly recommending The Grove!!!",
    user: "-Saad Haji",
    stars: 5,
  },
];
